module.exports = "ac 08 00 64 a4 08 00 68 a0 08 00 6c 8c 09 00 64 84 0a 00 68 80 0b 00 6c\n"